import CarCard from '../../Ui/ImageCard'

export function StickyHero() {
  return (
    <section className="sticky top-0 w-full z-10">
      <CarCard
        src="/assets/projects/shel.jpg"
        title="Shelby Supersnake"
        subtitle="Project Conversion"
        index="SYS·005"
        className="w-full aspect-[4/3] sm:aspect-auto sm:h-[450px] md:h-screen"
      />
    </section>
  )
}